import _ from 'lodash'
import MotionAdapter from './motion/index'
import botapiAdapter from './botapi/index'
import nuanceAdatper from './botapi/nuance'


export function getAdapter(config) {
  let backend = _.get(config, 'backend')

  if (backend === 'motion') {
    return new MotionAdapter(config)
  }
  if (backend === 'botapi') {
    return botapiAdapter(config)
  }
  if (backend === 'nuance') {
    return nuanceAdatper(config)
  }
  throw new Error(`Unknown chatbot backend ${backend}`)
}



// WEBPACK FOOTER //
// ./src/App/services/adapters/index.js